import React, { useState, useEffect } from 'react';
import '../static/css/CameraList.css'
import { List, Row, Col, Modal, message, Button } from 'antd';
import axios from 'axios'
import servicePath from '../config/apiUrl'


const { confirm } = Modal;

function BannerList(props) {
  const [list, setList] = useState([])

  const getList = () => {
    const key = 'getList';
    // console.log("servicePath.getBannerList", servicePath.getBannerList)
    message.loading({ content: '加载数据...', key });
    axios({
      method: 'get',
      url: servicePath.getBannerList,
    }).then(res => {
      if (res.data.code == 1) {
        setList(res.data.list)
        message.success({ content: '加载数据成功！', key, duration: 2 });
      } else {
        message.error({ content: '加载数据失败！', key, duration: 2 });
      }
    }).catch(() => {
      message.error({ content: '加载数据失败！', key, duration: 2 });
    })
  }

  useEffect(() => {
    getList()
  }, [])

  const deleteBanner = (id) => {
    confirm({
      title: '确定要删除该banner吗?',
      content: '如果你点击OK按钮，将会永远被删除，无法恢复。',
      onOk() {
        axios(servicePath.deleteBanner + '/' + id).then(res => {
          message.success('删除成功')
          getList()
        })
      },
      onCancel() {
        message.info('取消删除')
      },
    });
  }

  return (

    <div>
      <List
        header={
          <Row className="list-div">
            <Col span={3}><b>ID</b></Col>
            <Col span={6}><b>图片</b></Col>
            <Col span={4}><b>链接</b></Col>
            <Col span={4}><b>页面类型</b></Col>
            <Col span={7}><b>操作</b></Col>
          </Row>
        }
        bordered
        dataSource={list}
        renderItem={item => (
          <List.Item>
            <Row className="list-div">
              <Col span={3}>{item.id}</Col>
              <Col span={6}>
                <img src={servicePath.serverUrl + item.src} style={{width: '100px'}} alt="banner" />
              </Col>
              <Col span={4}>{item.url}</Col>
              <Col span={4}>{item.page_type || 'home'}</Col>
              <Col span={7}>
                <Button type="primary" onClick={() => props.history.push('/banner/editBanner/' + item.id)}>修改</Button>&nbsp;
                <Button onClick={() => deleteBanner(item.id)}>删除</Button>
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </div>
  )
}

export default BannerList